import { render } from "./Footer.vue?vue&type=template&id=6738bc3a&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=6738bc3a&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src231289078/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6738bc3a"],['__file',"src/components/sgre/Footer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6738bc3a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6738bc3a', __exports__)) {
    console.log('reload')
    api.reload('6738bc3a', __exports__)
  }
  
  module.hot.accept("./Footer.vue?vue&type=template&id=6738bc3a&scoped=true", () => {
    console.log('re-render')
    api.rerender('6738bc3a', render)
  })

}


export default __exports__